import React from 'react';
import { useNavigate } from 'react-router-dom';
import { giroTechLogo } from '../../utils/constants';

const AdminLayout = ({ user, onLogout, children, title, activeTab = null }) => {
  const navigate = useNavigate();

  const navigationItems = [
    { path: '/admin', label: 'Dashboard', icon: '🏠' },
    { path: '/admin/courses', label: 'Cursos', icon: '📚' },
    { path: '/admin/users', label: 'Usuários', icon: '👥' },
    { path: '/admin/groups', label: 'Grupos', icon: '🏢' },
    { path: '/admin/certificates', label: 'Certificados', icon: '🏆' },
    { path: '/admin/analytics', label: 'Analytics', icon: '📊' },
    { path: '/admin/progress', label: 'Progresso', icon: '📈' }
  ];

  const isActive = (path) => {
    if (path === '/admin') {
      return window.location.pathname === '/admin';
    }
    return window.location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with Logo */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <div className="flex items-center">
                <img src={giroTechLogo} alt="Giro.Tech" className="h-8 w-auto mr-3" />
                <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-600">Bem-vindo, {user?.name}</span>
              <button
                onClick={onLogout}
                className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
              >
                Sair
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-1 py-2">
            {navigationItems.map((item) => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${
                  isActive(item.path)
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <span className="mr-2">{item.icon}</span>
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
